import logoViabiliza from "@/assets/logo-viabiliza.png";

const Footer = () => {
  return (
    <footer className="text-center mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-border/30">
      <div className="flex justify-center mb-3">
        <img
          src={logoViabiliza}
          alt="Viabiliza"
          className="h-10 sm:h-12 w-auto object-contain opacity-80"
        />
      </div>
      <p className="text-xs sm:text-sm text-muted-foreground px-4">
        © 2025 Viabiliza es un producto de Unimos Gestión De Proyectos Y Desarrollo
      </p>
      <p className="text-xs sm:text-sm text-muted-foreground px-4 mt-1">
        Todos los derechos reservados
      </p>
    </footer>
  );
};

export default Footer;
